<template>
    <div>
        <vue-headful :title="$t('registration-results')" />
        <vs-card>
            <div slot="header" class="flex justify-between flex-wrap">
                <h3 class="mt-2 ml-2">{{ $t("options-filter") }}</h3>
                <div class="flex flex-wrap mt-2 lg:mt-0 pl-2 lg:pl-0">
                    <!-- Отчистка фильтров -->
                    <vs-button
                        color="warning"
                        :size="wMobile ? 'small' : ''"
                        class="mr-2"
                        v-show="filterActive"
                        @click="clearFilters"
                        >{{ $t("clear") }}</vs-button
                    >
                    <!-- Скрытие / показ фильтров -->
                    <vs-button
                        :size="wMobile ? 'small' : ''"
                        icon-pack="feather"
                        :icon="
                            filterActive
                                ? 'icon-chevron-up'
                                : 'icon-chevron-down'
                        "
                        @click="filterActive = !filterActive"
                        >{{
                            filterActive
                                ? $t("hide-filters")
                                : $t("show-filters")
                        }}</vs-button
                    >
                </div>
            </div>
            <div class="vx-row" v-show="filterActive">
                <!-- Рендер селектов по структуре -->
                <template v-for="select in listSelects">
                    <MySelect
                        v-if="showSelect(select) || !select.roles"
                        class="vx-col md:w-1/4 sm:w-1/2 w-full custom-select-filters"
                        style=""
                        :data="select"
                        :key="select.nameI18nAndQueryParam"
                    />
                </template>
                <div class="px-6 py-4 lg:hidden w-full">
                    <vs-button @click="filterActive = false" class="w-full">{{$t('apply')}}</vs-button>
                </div>
            </div>
        </vs-card>
        <div>
            <!-- Таблицы для разных типов таблиц -->
            <Results
                :active="versionTable === 1"
                :filters="editFilters"
                :ecxel="downloadExcel"
                v-if="versionTable === 1"
            />
            <Statistic
                :active="versionTable === 2"
                :filters="editFilters"
                v-if="versionTable === 2"
            />
            <Unregister
                :active="versionTable === 3"
                :filters="editFilters"
                v-if="versionTable === 3"
            />
        </div>
    </div>
</template>

<script>
import MySelect from "./Multiselect";
import Results from "./TableRegistrationResults";
import Statistic from "./TableRegistrationStatistics";
import Unregister from "./TableUnregisteredList";
export default {
    components: {
        MySelect,
        Results,
        Statistic,
        Unregister,
    },
    data() {
        return {
            versionTable: 0,
            filterActive: true,
            downloadExcel: false,
            editFilters: false,
            json_data: [],
            statusGetTable: true,
            listSelects: [
                {
                    nameI18nAndQueryParam: "advisor",
                    endpoint: "organizations/advisor_list/",
                    dependents: [],
                    roles: 'is_org_admin',
                    required: false
                },
                {
                    nameI18nAndQueryParam: "study_year",
                    endpoint: "common/study_years/",
                    dependents: [
                        "registration_period",
                        "faculty",
                        "cathedra",
                        "educational_program",
                        "course",
                        "group",
                    ],
                    required: true,
                },
                {
                    nameI18nAndQueryParam: "reg_period",
                    endpoint: "common/reg_periods/",
                    dependents: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "educational_program",
                        "course",
                        "group",
                        'advisor'
                    ],
                    params: ["study_year", "advisor"],
                    required: true,
                },
                {
                    nameI18nAndQueryParam: "acad_period",
                    endpoint: "advisors/acad_periods/",
                    dependents: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "educational_program",
                        "course",
                        "group",
                    ],
                    params: ["reg_period", "study_year"],
                },

                {
                    nameI18nAndQueryParam: "faculty",
                    endpoint: "advisors/faculties/",
                    params: ["study_year", "advisor"],
                    dependents: [
                        "cathedra",
                        "educational_program",
                        "course",
                        "group",
                    ],
                },

                {
                    nameI18nAndQueryParam: "edu_prog",
                    endpoint: "advisors/edu_programs/",
                    params: ["study_year", "faculty", "cathedra", "advisor"],
                    dependents: ["course", "group"],
                },
                {
                    nameI18nAndQueryParam: "course",
                    endpoint: "common/courses/",
                    dependents: ["group"],
                },
                {
                    nameI18nAndQueryParam: "group",
                    endpoint: "advisors/groups/",
                    params: [
                        "study_year",
                        "faculty",
                        "cathedra",
                        "educational_program",
                        "course",
                        "advisor"
                    ],
                },
                // {
                //     nameI18nAndQueryParam: "speciality",
                //     endpoint: "advisors/speciality/",
                //     params: [
                //         "study_year",
                //         "faculty",
                //         "cathedra",
                //         "educational_program",
                //         "course"
                //     ],
                // },
                {
                    nameI18nAndQueryParam: "versionTable",
                    endpoint: "reports/report_list/",

                    required: true,
                },
            ],
        };
    },
    watch: {
        "$route.query"() {
            this.checkSelectsDataForRequest()
        },
    },
    computed: {
        wMobile() {
            return this.$store.state.windowWidth < 600;
        },
        user() {
            return this.$store.state.user.user
        }
    },
    created() {
        this.checkSelectsDataForRequest()
    },
    methods: {
        showSelect(select) {
            if(this.user)
                return this.user.role[select.roles]
            else
                return false
        },
        // Получение статуса по получению загружаемой выбранной таблицы
        newStatusGetTable(status) {
            this.statusGetTable = status;
        },
        // Установка типа таблицы
        setVersionTable() {
            let query = this.$route.query;
            if (query["versionTable"] === "RegistrationResult") {
                this.versionTable = 1;
            } else if (query["versionTable"] === "RegistrationStatistics") {
                this.versionTable = 2;
            } else if (query["versionTable"] === "UnregisteredList") {
                this.versionTable = 3;
            } else this.versionTable = 0;
        },
        // Очистка фильтров
        clearFilters() {
            if (Object.keys(this.$route.query).length !== 0) {
                this.$router.replace({ name: this.$route.name, query: {} });
            }

            this.setVersionTable();
        },
        // Проверка обязательных фильтров
        checkSelectsDataForRequest() {
            // Получаю массив из обязательных полей из структуры
            const listRequired = this.listSelects.filter((obj) => obj.required);
            // Получаю массив из имеющихся заполненных обязательных селектов
            const numberQueryRequired = Object.keys(
                this.$route.query
            ).filter((key) =>
                this.listSelects.some(
                    (obj) => obj.nameI18nAndQueryParam === key && obj.required
                )
            );

            // Сравниваю, что все обязательные селекты заполнены и делаю запрос
            if (numberQueryRequired.length === listRequired.length) {
                this.setVersionTable();
                this.editFilters = true;
                setTimeout(() => {
                    this.editFilters = false;
                }, 1000);
            }
        },
        // Скачивание ecxel
        download() {
            this.downloadExcel = true;
            setTimeout(() => {
                this.downloadExcel = false;
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-select-filters::v-deep {
    .multiselect--active {
        z-index: 999999 !important;
    }
}
</style>
